<template>
    <v-row justify="center" align="center">
        <v-col cols="12" sm="12" md="12">
            <alert-message ref="errorAlert" :message="data.errorAlertMessage"></alert-message>

            <div v-if="loading" class="text-center">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                <p class="mt-3">Loading user information...</p>
            </div>

            <div v-else-if="authStore.currentUser">
                <h1>Account: {{ authStore.currentUser.email }}!</h1>
            </div>

            <div v-else class="text-center">
                <h1>Please sign in!</h1>
                <v-btn color="primary" @click="$router.push('/sign-in')"> Sign In </v-btn>
            </div>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import { defineComponent, reactive } from 'vue';
import { useAuthStore } from '../stores/AuthStore';
import AlertMessage from '../components/AlertMessage.vue';

export default defineComponent({
    name: 'Account',

    components: {
        AlertMessage
    },

    setup() {
        const authStore = useAuthStore();
        const data = reactive({
            errorAlertMessage: ''
        });
        return {
            authStore,
            data
        };
    },
    data() {
        return {
            loading: true
        };
    },
    async mounted() {
        try {
            await this.authStore.initializeCurrentUser();
        } catch (error) {
            console.error('Failed to initialize current user:', error);
            this.data.errorAlertMessage = 'Failed to load user information';
        } finally {
            this.loading = false;
        }
    },
    methods: {}
});
</script>
